import React from 'react'
import Helmet from 'react-helmet'

// Components
import { useForTablet } from 'components/Breakpoint'
import Footer from 'components/Footer'
import Navbar from 'components/Navbar'
import { SplitLayout } from 'layouts/SplitLayout'

import UserNavbarSection from 'modules/user/components/UserNavbarSection'

import { NoWorkspaceProjectsMenu } from 'modules/projects/components/ProjectsMenu/NoWorkspaceProjectsMenu'
import { ProjectsMenu } from 'modules/projects/components/ProjectsMenu'

import {
  SelectorSection,
  HamburgerButton,
  HamburgerIcon,
  SidebarWrapper,
  UserNavbarSectionWrapper,
  Margin,
} from './WorkspaceSidebarLayout.styles'

import { WorkspaceMinimalFragment } from 'gqlTypes'

// Utils
import { getCanAdministerShares } from 'modules/shares/utils'
import { showWorkspaceSettings } from '../../utils'
import theme from 'styles/theme'

interface WorkspaceSidebarLayoutProps {
  title: string
  currentWorkspace?: WorkspaceMinimalFragment
  workspaces?: WorkspaceMinimalFragment[]
  navbar?: React.ReactNode
  hideFooter?: boolean
}

const WorkspaceSidebarLayout: React.FC<WorkspaceSidebarLayoutProps> = props => {
  const {
    children,
    title,
    workspaces = [],
    currentWorkspace,
    navbar,
    hideFooter,
  } = props

  const isTabletAndBigger = useForTablet()
  const isSmallerThanTablet = !isTabletAndBigger

  const sidebar = (
    <SidebarWrapper>
      {!currentWorkspace || workspaces.length === 0 ? (
        <NoWorkspaceProjectsMenu />
      ) : (
        <ProjectsMenu
          workspace={currentWorkspace}
          workspaces={workspaces}
          showWorkspaceSettings={showWorkspaceSettings(currentWorkspace)}
          canUserAdministerShares={getCanAdministerShares(currentWorkspace)}
        />
      )}
    </SidebarWrapper>
  )

  return (
    <>
      <Helmet>
        <meta name="theme-color" content={theme.colors.gallery} />
      </Helmet>
      <SplitLayout
        title={title}
        header={({ setSidebarLeftOpen, isSidebarLeftOpen }) => (
          <Navbar
            isSidebarLeftOpen={isSidebarLeftOpen}
            singleContent={!navbar && !isSmallerThanTablet}>
            {isSmallerThanTablet && (
              <SelectorSection>
                <HamburgerButton onClick={() => setSidebarLeftOpen?.(true)}>
                  <HamburgerIcon />
                </HamburgerButton>
              </SelectorSection>
            )}
            {navbar}
            <UserNavbarSectionWrapper>
              <UserNavbarSection />
            </UserNavbarSectionWrapper>
          </Navbar>
        )}
        footer={!hideFooter && <Footer />}
        sidebar={sidebar}>
        <Margin>{children}</Margin>
      </SplitLayout>
    </>
  )
}

export default WorkspaceSidebarLayout
